import styled, { css } from 'styled-components'
import { Button, tokens } from '@arvoreeducacao/bonsai-ds'

export const ShelfWrapper = styled.section<{
  paddingRight?: number
  isLevelShelf?: boolean
}>`
  margin-bottom: ${({ isLevelShelf }) => (isLevelShelf ? 0 : 30)}px;
  min-height: ${({ isLevelShelf }) => (isLevelShelf ? 0 : 300)}px;
  ${({ paddingRight }) => css`
    @media (max-width: ${tokens.sizes.smScreen}px) {
      padding-right: ${paddingRight || 0}px;
    }
  `};
`
export const ShelfHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${tokens.sizes.mdScreen}px) {
    padding-left: 10px;
  }
`

export const Title = styled.h2`
  font-weight: ${tokens.fontWeights.bold};
  color: ${tokens.colors.dark6};
  font-size: ${tokens.fontSize.xlarge};

  @media (max-width: ${tokens.sizes.mdScreen}px) {
    font-size: ${tokens.fontSize.large};
    margin: 0;
    margin-bottom: 8px;
    padding: 0;
  }
`
export const Subtitle = styled.p`
  margin-left: ${tokens.spacing.horizontalMedium};
  padding-top: 3px;
  font-weight: ${tokens.fontWeights.regular};
  font-size: ${tokens.fontSize.medium};
  color: ${tokens.colors.dark5};

  @media (max-width: ${tokens.sizes.mdScreen}px) {
    margin: 0;
    padding: 0;
  }
`

export const ShelfDescription = styled.div`
  display: flex;
  align-items: center;
  margin-left: ${tokens.spacing.horizontalXsmall};

  @media (max-width: ${tokens.sizes.mdScreen}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const BtnShelf = styled(Button)`
  transition: 0.1s;
  background: none;
  &:hover {
    background-color: ${tokens.colors.dark1};
    transition: 0.1s;
  }
  &:focus-visible {
    outline: 2px solid ${tokens.colors.dark6};
    outline-offset: 2px;
  }
  img {
    margin-left: 5px;
  }
`
export const BtnShelfText = styled.span`
  text-decoration: none;
  color: ${tokens.colors.dark5};
  font-weight: ${tokens.fontWeights.bold};
  font-size: ${tokens.fontSize.medium};
  font-family: ${tokens.fontFamily.base};
  margin-right: 8px;

  @media (max-width: ${tokens.sizes.mdScreen}px) {
    display: none;
  }
`

export const EllipsisWrapper = styled.div`
  border-radius: ${tokens.radius.circular};
  background-color: ${tokens.colors.blue200};
  width: ${tokens.spacing.horizontalXxlarge};
  height: ${tokens.spacing.verticalXxlarge};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${tokens.spacing.horizontalXsmall};
`
